import { api } from '../index'

export default {
  all(success, failure) {
    return api.get('/gardens/filters')
      .then((response) => success(response))
      .catch((error) => failure(error))
  },
}
